export const bigdesDefinitionsTabsConfig = {
  basePath: "/bigdes-operations/definitions",
  tabs: [
    {
      id: "circular-article-definitions",
      path: "/bigdes-operations/definitions/circular-article-definitions",
      pageKey: "bigdesDefinitionsCircularArticleDefinitions",
    },
    {
      id: "measures",
      path: "/bigdes-operations/definitions/measures",
      pageKey: "bigdesDefinitionsMeasures",
    },
  ],
};
